import { Injectable } from '@angular/core';
import { AppConfig } from '../../app/app.config';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {
  JackingArrivalPositioningFile
} from '../../models/projects/jacking-activity.models';
import {JackingUploadTarget} from '../../pages/jacking-activities/v1/jacking-activity-file-upload-modal/jacking-activity-file-upload-modal';

@Injectable()
export class JackingActivityFileUploadService {

  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
  ) {
  }

  public getUploadedFiles(target: JackingUploadTarget): Observable<JackingArrivalPositioningFile[]> {
    const url = target.kind === 'v1'
      ? `${this.config.apiUrl}api/jacking/${target.jackingActivityId}/files`
      : `${this.config.apiUrl}api/jacking-v2/${target.jackingFormInstanceId}/files`;

    return this.http.get<JackingArrivalPositioningFile[]>(url);
  }

  public uploadFile(f: File, target: JackingUploadTarget): Observable<HttpEvent<JackingArrivalPositioningFile>> {
    const url = target.kind === 'v1'
      ? `${this.config.apiUrl}api/jacking/${target.jackingActivityId}/upload-file`
      : `${this.config.apiUrl}api/jacking-v2/${target.jackingFormInstanceId}/upload-file`;

    const formData = new FormData();
    formData.append('file', f, f.name); // important: stable field name

    return this.http.post<JackingArrivalPositioningFile>(url, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  public deleteFile(positioningReportId: number) {
    const url = `${this.config.apiUrl}api/jacking/${positioningReportId}/delete-file`;
    return this.http.get(url);
  }

  public downloadFile(guid: string): Observable<Blob> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    const url = `${this.config.apiUrl}api/jacking/${guid}/get-file`;
    return this.http.get(url, { headers, responseType: 'blob' });
  }
}



// WEBPACK FOOTER //
// ./src/services/jacking-activity/jacking-activity-file-upload.service.ts